// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a5950e7a","239":"f4032513","453":"00e6d5b4","553":"8b51b04a"}[chunkId] + ".chunk.js";
};